"use strict";

var _ = require('lodash');

var React = require('react');

var _require = require('../composites/compositeUtils'),
    buildValidationError = _require.buildValidationError;

var _require2 = require('../composites/childValidation'),
    validationType = _require2.validationType;

var displayNames = require('../controls/displayNames');

var getChildDisplayName = function getChildDisplayName(child) {
  var getDisplayName = _.get(child, 'type.getDisplayName') || _.get(child, 'getDisplayName');

  return getDisplayName ? getDisplayName() : null;
};

var getChildrenDisplayNames = function getChildrenDisplayNames(children) {
  return _.flatten(React.Children.map(children, function (child) {
    var getChildrenTypes = _.get(child, 'type.getChildrenTypes');

    if (_.isFunction(getChildrenTypes)) {
      return getChildrenTypes(child.props).map(function (c) {
        return getChildDisplayName(c);
      });
    }

    var displayName = getChildDisplayName(child);
    return displayName === displayNames.TOOLTIP ? getChildDisplayName(child.props.children) : displayName;
  }));
};

var createCompositeChildrenValidation = function createCompositeChildrenValidation(compositeDef) {
  return function (props, propName, componentName) {
    var expectedTypes = compositeDef.childrenTypes;
    var actualNames = getChildrenDisplayNames(props.children);

    if (expectedTypes.validation === validationType.ANY) {
      return;
    }

    var actualIndex = 0;

    for (var i = 0; i < expectedTypes.length; i++) {
      var expectedType = expectedTypes[i].validation;
      var expectedNames = expectedTypes[i].names || null;
      var actualName = actualNames[actualIndex];

      switch (expectedType) {
        case validationType.ONCE:
          {
            if (!_.includes(expectedNames, actualName)) {
              return buildValidationError(componentName, expectedTypes);
            }

            actualIndex++;
            break;
          }

        case validationType.OPTIONAL:
          {
            if (_.includes(expectedNames, actualName)) {
              actualIndex++;
            }

            break;
          }

        case validationType.MULTIPLE:
          {
            if (!_.includes(expectedNames, actualName)) {
              return buildValidationError(componentName, expectedTypes);
            }

            while (_.includes(expectedNames, actualNames[++actualIndex])) {
              /* empty */
            }

            break;
          }
      }
    }

    if (actualNames[actualIndex]) {
      return buildValidationError(componentName, expectedTypes);
    }
  };
};

module.exports = createCompositeChildrenValidation;